import Domains from "./constants/domain.ts";
export const Images = () => {
  
    return {
      AldiBanner1: require("../assets/images/bg_1.jpg"),
      AldiBanner2: require("../assets/images/bg_2.jpg"),
      AldiBanner3: require("../assets/images/bg_3.jpeg"),
      mmLogo: require("../assets/common/images/MM-logo.jpg"),
    };
    //   return require('../assets/common/images/default-image.jpg');
  }

